module.exports = __webpack_public_path__ + "img/edc5303.jpg";